import { configureStore, createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";

export const date = createSlice({
  name: "date",
  initialState: {
    year: new Date().getFullYear(),
    month:
      new Date().getDate() >= 17
        ? new Date().getMonth() + 1
        : new Date().getMonth(),
  },
  reducers: {
    prevMonth: (state: any) => {
      if (state.month === 1) {
        state.year -= 1;
        state.month = 12;
        return;
      } else {
        state.month -= 1;
      }
    },
    nextMonth: (state: any) => {
      if (state.month === 12) {
        state.year += 1;
        state.month = 1;
        return;
      } else {
        state.month += 1;
      }
    },
  },
});

export const main = createSlice({
  name: "main",
  initialState: {
    data: [],
    typeList: [],
  },
  reducers: {
    setBudget: (state: any, value: PayloadAction<any>) => {
      state.data = value.payload;
    },
    setTypeList: (state: any, value: any) => {
      state.typeList = value;
    },
  },
});

export default configureStore({
  reducer: {
    date: date.reducer,
    main: main.reducer,
  },
});

export const { prevMonth, nextMonth } = date.actions;
export const { setBudget, setTypeList } = main.actions;
